import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button3Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M5 8H11V0H5V8ZM5 17H11V10H5V17ZM0 19H3V15H4V12H3H0V15V19ZM13 19H16V15V12H13H12V15H13V19Z" />
  </SvgIcon>
);

export default PO28Button3Icon;
